import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from "firebase/auth";
import { motion } from "framer-motion";
import LottiePlayer from "lottie-react";
import { useState } from "react";
import { FiArrowLeft } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import loadingAnimation from "../animations/loader.json";
import { auth } from "../functions/firebase";

export default function LoginInit() {

    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")

    const navigate = useNavigate()
    const [isSignIn, setIsSignIn] = useState(false)
    const [loading, setLoading] = useState(false)

    function verifyNumber(e) {

        if(e?.preventDefault) {
            e.preventDefault()
        }

        setLoading(true)

        const authenticate = isSignIn ? signInWithEmailAndPassword : createUserWithEmailAndPassword

        authenticate(auth, email, password)
            .then((user) => {
                setLoading(false)
                navigate("/auth-1/" + user.user.uid)

            }).catch((error) => {
                setLoading(false)
                alert(error.message)
        });

    }


    return (
        <>
        <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
        >
            <div id="authForm">
                <div className="row" style={{ width: "100%", marginBottom: 20 }}>
                    <FiArrowLeft 
                        color="grey"
                        className="back-button"
                        size={30}
                        onClick={() => window.history.back()}
                    />
                    <div>
                        <p>Rasking</p>
                    </div>
                </div>
                <form  onSubmit={verifyNumber}>

                    <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
                        <button 
                            style={{ 
                                fontSize: 14,
                                backgroundColor: !isSignIn ? "var(--primary)" : "var(--card)"
                            }}
                            onClick={(event) => {
                                event.preventDefault()
                                setIsSignIn(false)
                            }}
                        >Register</button>
                        <button 
                            style={{ 
                                fontSize: 14,
                                backgroundColor: isSignIn ? "var(--primary)" : "var(--card)"
                            }}
                            onClick={(event) => {
                                event.preventDefault()
                                setIsSignIn(true)
                            }}
                        >Signin</button>
                    </div>
                    
                    <div>
                        <input 
                            placeholder="Your Email"
                            type="email"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                        />
                    </div>
                    <div>
                        <input 
                            placeholder="Password"
                            type="password"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                        />
                    </div>
                    
                    <p style={{ marginBottom: 20, color: "grey" }}>Terms and condition apply</p>
                    <button type="submit" id="sign-in-button">Continue</button>
                </form>
            </div>
            <motion.div className="log-footer">
                <p>A Kulture Product</p>
            </motion.div>
        </motion.div>
            {loading && (
                <div style={{
                    position: 'absolute',
                    bottom: 0,
                    width: '100vw',
                    height: "10vh",
                    backgroundColor: '#171717',
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "row"
                }}>
                    <LottiePlayer 
                        animationData={loadingAnimation}
                        loop={true}
                        style={{
                            width: 50,
                        }}
                    />
                    <p style={{ color: "white" }}>Reload if screen becomes grey...</p>
                </div>
            )}
        </>
        
    )
}